import * as React from 'react';

import LectureCancelContainer from '../../containers/LectureCancel';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * 受講取消画面
 * @param props
 */
const LectureCancel: React.FC<any> = props => {
	const skillViewFlg = props.location.state.skillViewFlg;
	return (
		<>
			<MainMenu />
			<Navbar
				title={
					skillViewFlg
						? i18n.t('LectureCancel_0014')
						: i18n.t('LectureCancel_0015')
				}
			/>
			<LectureCancelContainer {...props} />
		</>
	);
};

export default LectureCancel;



// WEBPACK FOOTER //
// ./src/pages/personal/LectureCancel.tsx